export function normalizeSortByForSource(source: string, sortBy: string | null | undefined): string | undefined {
  const currentSortBy = String(sortBy || '');
  if (source === 'estaff' && currentSortBy === 'date_updated') {
    return 'status_date_desc';
  }
  if (source !== 'estaff' && currentSortBy.startsWith('status_date_')) {
    return 'relevance';
  }
  return undefined;
}
